import { LazyAction, LazyModule } from 'owa-bundling';
const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "RecipientPermissionChecker" */ './lazyIndex')
);

export const lazyTryCheckPermForLinks = new LazyAction(lazyModule, m => m.tryCheckPermForLinks);
export const lazyTryCheckPermForOneLink = new LazyAction(lazyModule, m => m.tryCheckPermForOneLink);
export const lazyExpandSmallDLs = new LazyAction(lazyModule, m => m.expandSmallDLs);
